<template>
    <div class="loading">
        <img src="@/assets/loading.gif"/>
    </div>
</template>

<script>
    export default {
        name: ""
    }
</script>

<style lang="scss" scoped>
    .loading{
        width: 100%;
        height: 100vh;
        position: fixed;
        background: #fff;
        z-index: 100;
        line-height: 100vh;
        text-align: center;
        top: 0;
        img{
            width: 80px;
            height: 80px;
        }
    }
</style>
